export enum AccialCreditNoteStatusEnum {
  CREATED = 'CREATED',
  UPDATED = 'UPDATED',
  UNCHANGED = 'UNCHANGED',
  PROCESSED_WITH_DIFFERENCES = 'PROCESSED_WITH_DIFFERENCES',
  NOT_FOUND = 'NOT_FOUND',
  BILL_NOT_FOUND = 'BILL_NOT_FOUND',
  CONFLICT = 'CONFLICT',
  ERROR = 'ERROR',
}

export enum AccialCreditNoteStatusDict {
  'CREATED' = 'Creada',
  'UPDATED' = 'Actualizada',
  'UNCHANGED' = 'Sin cambios',
  'PROCESSED_WITH_DIFFERENCES' = 'Con diferencias',
  'NOT_FOUND' = 'No encontrada en Siigo',
  'BILL_NOT_FOUND' = 'Sin factura asociada',
  'CONFLICT' = 'Conflicto',
  'ERROR' = 'Error',
}

export enum AccialCreditNoteStatusDetailDict {
  'CREATED' = 'No existía localmente y se creó desde Siigo',
  'UPDATED' = 'Existía sin diferencias resueltas y se actualizaron sus datos financieros',
  'UNCHANGED' = 'Ya coincidía con Siigo, no se modificó',
  'PROCESSED_WITH_DIFFERENCES' = 'Ya estaba procesada; se reportan las diferencias sin modificarla',
  'NOT_FOUND' = 'No apareció en Siigo tras paginar',
  'BILL_NOT_FOUND' = 'No existe una factura para ese número',
  'CONFLICT' = 'Nombre duplicado con distinto número, o el nombre no coincide con el de Siigo',
  'ERROR' = 'Falla de validación o excepción al procesarla',
}

/** Campos financieros que el backend reporta como diferentes frente a Siigo. */
export enum AccialCreditNoteFieldDict {
  'total' = 'Total',
  'balance' = 'Saldo',
  'paymentDueDate' = 'Fecha de vencimiento',
  'paymentDate' = 'Fecha de pago',
  'billId' = 'Factura',
  'number' = 'Número',
  'name' = 'Nombre',
}

export enum AccialCreditNoteStatusToneDict {
  'CREATED' = 'success',
  'UPDATED' = 'success',
  'UNCHANGED' = 'neutral',
  'PROCESSED_WITH_DIFFERENCES' = 'warning',
  'NOT_FOUND' = 'error',
  'BILL_NOT_FOUND' = 'error',
  'CONFLICT' = 'error',
  'ERROR' = 'error',
}
